"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var useMediaQuery_1 = __importDefault(require("../hooks/useMediaQuery"));
var Layout_1 = __importDefault(require("../context/Layout"));
var useLayoutLinks_1 = __importDefault(require("./hooks/useLayoutLinks"));
var useTranslations_1 = __importDefault(require("./hooks/useTranslations"));
var useHeaderTheme_1 = __importDefault(require("./hooks/useHeaderTheme"));
var ImpersonationBanner_1 = __importDefault(require("../ImpersonationBanner"));
var useCatalogLink_1 = __importDefault(require("../hooks/useCatalogLink"));
var useAnalytics_1 = __importDefault(require("./hooks/useAnalytics"));
var styles_1 = require("./styles");
var VariableHeader_1 = __importDefault(require("./VariableHeader"));
var MobileContainer_1 = __importDefault(require("./MobileContainer"));
var multipleBanksFunctions_1 = require("./multipleBanksFunctions");
var prism_utilities_1 = require("@octanner/prism-utilities");
var Header = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var fullStoryOrg = _a.fullStoryOrg, isImpersonating = _a.isImpersonating, specialPointName = _a.specialPointName, onStopImpersonation = _a.onStopImpersonation, routerPath = _a.routerPath, routerPush = _a.routerPush, _h = _a.routerRoutes, routerRoutes = _h === void 0 ? [] : _h, referrerUrl = _a.referrerUrl, _j = _a.variant, variant = _j === void 0 ? 'normal' : _j, logoutUrl = _a.logoutUrl, props = __rest(_a, ["fullStoryOrg", "isImpersonating", "specialPointName", "onStopImpersonation", "routerPath", "routerPush", "routerRoutes", "referrerUrl", "variant", "logoutUrl"]);
    var headerTheme = (0, useHeaderTheme_1.default)();
    var isMobile = (0, useMediaQuery_1.default)('@media (max-width: 768px)');
    var _k = __read((0, react_1.useContext)(Layout_1.default), 3), currentIdentityQuery = _k[0], layoutQuery = _k[1], localeQuery = _k[2];
    var lang = (0, useTranslations_1.default)((_b = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _b === void 0 ? void 0 : _b.currentIdentity, (_d = (_c = localeQuery === null || localeQuery === void 0 ? void 0 : localeQuery.data) === null || _c === void 0 ? void 0 : _c.customerCoreLocaleMapsByCustomer) === null || _d === void 0 ? void 0 : _d.nodes).lang;
    var currentIdentity = (_e = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _e === void 0 ? void 0 : _e.currentIdentity;
    var links = (0, useLayoutLinks_1.default)(layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data);
    var bankUrl = (0, useCatalogLink_1.default)({ referrerUrl: referrerUrl, lang: lang });
    var ccuiMultipleBanksP240315 = (0, prism_utilities_1.useFlags)().ccuiMultipleBanksP240315;
    var testRoute = function (url) { return function (route) {
        return route.length > 1 ? url.startsWith(route) : url === route;
    }; };
    var layout = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data;
    var headerView = variant === 'normal' ? true : false;
    var bank = ((_f = layout === null || layout === void 0 ? void 0 : layout.bankBalance) === null || _f === void 0 ? void 0 : _f.find(function (bank) { return bank.defaultBank; })) ||
        ((_g = layout === null || layout === void 0 ? void 0 : layout.bankBalance) === null || _g === void 0 ? void 0 : _g[0]);
    var hasMultipleBank = (layout === null || layout === void 0 ? void 0 : layout.bankBalance) &&
        layout.bankBalance.length > 1 &&
        ccuiMultipleBanksP240315;
    var _l = (0, multipleBanksFunctions_1.getMultipleBanks)(layout, currentIdentity, hasMultipleBank), vettedMultipleBanks = _l.vettedMultipleBanks, accessCodes = _l.accessCodes;
    (0, useAnalytics_1.default)({
        currentIdentity: currentIdentity,
        fullStoryOrg: fullStoryOrg,
        links: links,
        bank: bank,
    });
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: headerTheme },
        currentIdentity && isImpersonating && (react_1.default.createElement(ImpersonationBanner_1.default, { identity: currentIdentity, onStopImpersonation: onStopImpersonation })),
        react_1.default.createElement(styles_1.HeaderContainer, __assign({}, props), isMobile ? (react_1.default.createElement(MobileContainer_1.default, { multipleBanksObj: {
                hasMultipleBank: hasMultipleBank,
                multipleBanks: vettedMultipleBanks,
                accessCodes: accessCodes,
                bankUrl: bankUrl,
            }, routerObj: { routerPush: routerPush, routerRoutes: routerRoutes, testRoute: testRoute }, logoutUrl: logoutUrl })) : (react_1.default.createElement(VariableHeader_1.default, { headerView: headerView, logoutUrl: logoutUrl, multipleBanksObj: {
                hasMultipleBank: hasMultipleBank,
                multipleBanks: vettedMultipleBanks === null || vettedMultipleBanks === void 0 ? void 0 : vettedMultipleBanks.concat((0, multipleBanksFunctions_1.sortAccess)(accessCodes)),
                suppliedSpecialPointName: specialPointName,
                bank: bank,
                bankUrl: bankUrl,
            }, routerObj: { routerPush: routerPush, routerRoutes: routerRoutes, routerPath: routerPath, testRoute: testRoute } })))));
};
exports.default = Header;
//# sourceMappingURL=Header.js.map